export enum ScreenType {
    small = 576,
    medium = 768,
    large = 900,
    tablet = 1200,
    laptop = 1440,
}
